import React, { useEffect, useMemo, useState } from "react";

const SearchBar = ({ onSearch, value, className }) => {
  const phrases = useMemo(() => [
    "Search raag by name...",
    "Search raag by mood...",
    "Search raag by thaat...",
    "Try Yaman, Bhairav, Desh, Kafi..."
  ], []);

  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(100);

  useEffect(() => {
    const fullText = phrases[loopNum % phrases.length];

    const handleTyping = () => {
      setDisplayText(prev =>
        isDeleting
          ? fullText.substring(0, prev.length - 1)
          : fullText.substring(0, prev.length + 1)
      );

      if (!isDeleting && displayText === fullText) {
        setTimeout(() => setIsDeleting(true), 1500);
        setTypingSpeed(50);
      } else if (isDeleting && displayText === "") {
        setIsDeleting(false);
        setLoopNum(prev => prev + 1);
        setTypingSpeed(100);
      }
    };

    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [displayText, isDeleting, loopNum, typingSpeed, phrases]);

  return (
    <div className="relative w-full">
      <input
        type="text"
        placeholder={displayText}
        value={value}
        onChange={(e) => onSearch(e.target.value)}
        className={`transition-all ${className}`}
      />
    </div>
  );
};

export default SearchBar;
